/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import styled from "styled-components";

import {
  StyledDeleteButton,
  StyledDeleteImage,
  StyledHelperText,
  StyledLabel,
  StyledRequired,
  StyledSpacer14,
} from "../superAdmin/catalog/lib/styles";
import { theme } from "../theme/theme";

const trash = require("../svg/trash.svg");

const StyledContainer = styled.div`
  display: inline-block;
  width: calc(100% - 270px);
`;

const StyledImagePreview = styled.div`
  float: left;
  margin-right: 12px;
  border: 1px solid ${theme.color.grayLightest};
  border-radius: 8px;
  width: 244px;
  height: 155px;
  overflow: hidden;
  text-align: center;
`;

const StyledImage = styled.img`
  height: 155px;
`;

const StyledDelete = styled(StyledDeleteButton)`
  top: 5px;
  left: 8px;
`;

const StyledButtonContainer = styled.div`
  span.disabled {
    opacity: 0.38;
    cursor: default;
  }
`;

const StyledHelper = styled(StyledHelperText)`
  margin-bottom: 0px;
`;

const StyledHiddenInput = styled.input`
  && {
    display: none;
  }
`;

const StyledName = styled.p`
  margin-bottom: 16px;
  display: block;
`;

const StyledUploadButton = styled.label`
  background: ${theme.color.white};
  border: 2px solid ${theme.color.gray};
  border-radius: ${theme.spacing.xxl};
  color: ${theme.color.grayDarkest};
  font-family: ${theme.fontFamily};
  font-size: ${theme.fontSize.xs};
  font-weight: 800;
  letter-spacing: ${theme.letterSpacing.s};
  line-height: 15px;
  padding: ${theme.spacing.xxs} ${theme.spacing.xs};
  margin-bottom: 0px;
  text-transform: uppercase;
`;

type FileUploadFieldPropTypes = {
  disabled?: boolean;
  fileAltText?: string;
  fileName?: string;
  fileUrl?: string;
  handleChange: (event) => void;
  handleDelete: (event) => void;
  helperText?: string | React.ReactChild;
  id: string;
  isRequired?: boolean;
  label?: string;
};

const FileUploadField = ({
  disabled,
  fileAltText,
  fileName,
  fileUrl,
  handleChange,
  handleDelete,
  helperText,
  id,
  isRequired,
  label,
}: FileUploadFieldPropTypes): React.ReactElement => {
  // NOTE: need to reset the value when input is clicked to reset the file uploader
  const resetValue = (event) => {
    event.target.value = "";
  };

  return (
    <>
      {label && (
        <StyledLabel>
          {label}
          {isRequired && <StyledRequired>*</StyledRequired>}
        </StyledLabel>
      )}
      <div data-testid={`${id}-file-upload`} style={{ overflow: "hidden" }}>
        {fileUrl && (
          <StyledImagePreview data-testid={`${id}-preview`}>
            <StyledImage alt={fileAltText} src={fileUrl} />
          </StyledImagePreview>
        )}
        <StyledContainer>
          {fileName && (
            <StyledName data-testid={`${id}-file-name`}>{fileName}</StyledName>
          )}
          <StyledButtonContainer>
            <StyledHiddenInput
              accept="image/jpeg, image/jpg, image/png"
              data-testid={`${id}-file-upload-input`}
              disabled={disabled}
              id={id}
              onChange={handleChange}
              onClick={resetValue}
              type="file"
            />
            <StyledUploadButton
              htmlFor={id}
              className={disabled ? "disabled" : null}
            >
              Choose File
            </StyledUploadButton>

            {fileName && (
              <StyledDelete
                disabled={disabled}
                onClick={handleDelete}
                size="small"
                testId="delete-file-button"
                variant="secondary"
              >
                <StyledDeleteImage src={trash} alt="trash icon" />
              </StyledDelete>
            )}
          </StyledButtonContainer>

          {helperText && (
            <div>
              <StyledSpacer14 />
              <StyledHelper>{helperText}</StyledHelper>
            </div>
          )}
        </StyledContainer>
      </div>
    </>
  );
};

FileUploadField.defaultProps = {
  fileAltText: "logo preview",
  fileName: "",
  fileUrl: "",
  label: "",
  helperText: "",
  isRequired: false,
};

export default FileUploadField;
